import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import {
  Dialog as MuiDialog,
  DialogContent as MuiDialogContent,
  DialogContentText as MuiDialogContentText,
  DialogActions as MuiDialogActions,
  Button as MuiButton,
} from '@mui/material';
import archivedIcon from 'assets/images/archived-icon.svg';

const ArchivePopup = ({ onCancel, onSave, open, title, subtitle }) => {
  const { t } = useTranslation();

  return (
    <MuiDialog open={open}>
      <SDialogContent>
        <SIconWrapper>
          <SImg src={archivedIcon} />
        </SIconWrapper>
        <MuiDialogContentText>
          <STitle>{title}</STitle>
          <SSubTitle>{subtitle}</SSubTitle>
        </MuiDialogContentText>
      </SDialogContent>
      <SDialogActions>
        <SMuiButton
          type="submit"
          variant="outlined"
          onClick={onCancel}
          color="primary"
        >
          {t('Not now')}
        </SMuiButton>
        <SMuiButton
          type="submit"
          variant="contained"
          onClick={onSave}
          color="primary"
        >
          {t('Yes')}
        </SMuiButton>
      </SDialogActions>
    </MuiDialog>
  );
};

const SDialogContent = styled(MuiDialogContent)`
  && {
    padding: 0 50px;
  }
`;

const SImg = styled.img`
  && {
    display: block;
    width: 96px;
    height: 96px;
  }
`;

const SIconWrapper = styled.div`
  && {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding: 40px 0 30px;
  }
`;

const STitle = styled.div`
  width: 65%;
  font-weight: 600;
  margin: 10px auto 0;
  font-size: 20px;
  line-height: 27px;
  text-align: center;
  color: ${({theme}) => theme.palette.colors.black100};
`;
const SSubTitle = styled.div`
  width: 55%;
  font-weight: 600;
  font-size: 12px;
  line-height: 22px;
  text-align: center;
  margin: 10px auto 0;
  color: ${({theme}) => theme.palette.colors.gray400};
`;
const SDialogActions = styled(MuiDialogActions)`
  && {
    margin: 30px 0 50px;
    padding: 0 50px;
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: center;
  }
`;
const SMuiButton = styled(MuiButton)`
  && {
    min-width: 115px;
    padding: 5px 33px;
    margin-right: 10px;
  }
`;

export default ArchivePopup;
